import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { defaultSecuritySettings, SecuritySettings } from '../../../../core/models';
import {FormGroupRecord} from '../../../../core/types/form.type';
import {regexable} from '../../../../core/validators/regexable.validator';

@Component({
    selector: 'app-security-settings',
    templateUrl: './security-settings.component.html',
    styleUrls: ['./security-settings.component.scss'],
    standalone: false
})
export class SecuritySettingsComponent implements OnInit, OnChanges {

  @Input() settings: SecuritySettings | undefined;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  value: SecuritySettings = this.getSettingsValue();
  form: FormGroupRecord<SecuritySettings> = new FormGroup({
    mail: new FormArray([]),
    skip_ip_check: new FormControl<boolean>(this.value.skip_ip_check),
    anti_virus: new FormGroup({
      mail: new FormControl(this.value.anti_virus.mail, Validators.email)
    }),
    hazardous_file: new FormGroup({
      mail: new FormControl(this.value.hazardous_file.mail, Validators.email),
      allowed_types: new FormArray([]),
      notifications: new FormGroup({
        user: new FormControl(this.value.hazardous_file.notifications.user),
        profile: new FormControl(this.value.hazardous_file.notifications.profile)
      })
    })
  });

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      let disabled = this.form.disabled;
      this.settings = changes['settings'].currentValue;
      if (this.settings) {
        this.value = this.getSettingsValue();
      }
      this.setArrayValues();
      this.form.patchValue(this.value);
      if (disabled) {
        this.form.disable();
      }
    }
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = this.getSettingsValue();
    this.setArrayValues();
    this.form.reset(this.value);
    this.form.disable();
  }

  setArrayValues(): void {
    this.mails.clear();
    this.allowedTypes.clear();
    this.value.mail.forEach(() => this.doAddMail());
    this.value.hazardous_file.allowed_types.forEach(() => this.addAllowedType());
  }

  doSave(): void {
    this.saveSettings.emit(this.form);
    this.form.disable();
  }

  doAddMail(): void {
    this.mails.push(new FormControl('', [Validators.required, Validators.email, Validators.maxLength(100)]));
  }

  doRemoveMail(index: number): void {
    this.mails.removeAt(index);
  }

  get mails(): FormArray {
    return this.form.get('mail') as FormArray;
  }

  mailAt(index: number): FormControl {
    return this.mails.at(index) as FormControl;
  }

  get allowedTypes(): FormArray {
    return this.form.controls.hazardous_file.controls.allowed_types;
  }

  addAllowedType(): void {
    this.allowedTypes.push(new FormControl('', [Validators.required, regexable()]));
  }

  removeAllowedType(index: number): void {
    this.allowedTypes.removeAt(index);
  }

  getSettingsValue(): SecuritySettings {
    return structuredClone({ ...defaultSecuritySettings, ...(this.settings || {}) })
  }


}
